import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';

import Loading from './Loading';
import { fetchApplicationConfig } from '../config';

/**
 * This component will wait for the application config to load before showing it's children
 */
const ConfigurationBarrier: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [fetchStatus, setFetchStatus] = useState<'fetching' | 'success' | 'failed'>('fetching');

  useEffect(() => {
    fetchApplicationConfig()
      .then(config => setFetchStatus('success'))
      .catch(() => setFetchStatus('failed'));
  }, []);

  switch (fetchStatus) {
    case 'fetching':
      return <Loading />;
    case 'success':
      return <>{children}</>;
    case 'failed':
      return <Typography align="center">Failed to load config.</Typography>;
  }
};

export default ConfigurationBarrier;
